import React from "react";
import { ChequeredCard } from "../ChequeredCard";
import { Grid } from "../Grid";

interface Data {
  title: string;
  content: string;
  link?: string;
}
export interface BasicChequeredBoardProps {
  content: Data[];
}

export const BasicChequeredBoard: React.FC<BasicChequeredBoardProps> = ({ content }) => (
  <Grid data-testid="BasicChequeredBoard" grid={["100%", "100%", "33.33%", "33.33%", "33.33%"]}>
    {content.map((d, index) => (
      <ChequeredCard key={d.title} title={d.title} content={d.content} link={d.link} variant={index % 2 === 0 ? "chequered" : "solid"} />
    ))}
  </Grid>
);
